import { render, staticRenderFns } from "./CourseTestList.vue?vue&type=template&id=18d8681b&scoped=true&"
import script from "./CourseTestList.vue?vue&type=script&lang=js&"
export * from "./CourseTestList.vue?vue&type=script&lang=js&"
import style0 from "./CourseTestList.vue?vue&type=style&index=0&id=18d8681b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d8681b",
  null
  
)

export default component.exports